export default {
  title: 'Ferramentas',
  bulkRecalcTitle: 'Recalcular Model Reports em massa',
  bulkRecalcDescription: 'Gera novamente o Model Report dos modelos cujo relatório foi gerado dentro de um intervalo de datas. Use para atualizar relatórios anteriores a funcionalidades mais recentes.',
  afterDateLabel: 'Gerado depois de',
  beforeDateLabel: 'Gerado antes de',
  typesLabel: 'Tipos de modelo',
  typeAdHoc: 'Ad-hoc',
  typeDiy: 'DIY',
  typeCustomEkrm: 'Custom EKRM',
  typeCustomReference: 'Custom Reference',
  batchSizeLabel: 'Modelos em paralelo',
  maxModelsLabel: 'Máx. de modelos',
  maxModelsHint: '0 = sem limite',
  previewButton: 'Pré-visualizar',
  matchesTitle: '{count} modelos correspondentes',
  recalculateButton: 'Recalcular {count} modelos',
  undeterminedNote: '{count} modelos têm um relatório cuja data de geração não pôde ser determinada e foram excluídos.',
  headerName: 'Modelo',
  headerType: 'Tipo',
  headerDate: 'Data do relatório',
  headerQuality: 'Qualidade',
  confirmTitle: 'Confirmar recálculo',
  confirmMessage: 'Isto iniciará o recálculo de {count} modelos. Continuar?',
  cancel: 'Cancelar',
  confirm: 'Recalcular',
  progressLabel: 'Recalculando {done} de {total} modelos...',
  doneMessage: 'Recálculo concluído para {count} modelos.',
  errorMessage: 'Algo deu errado. Por favor, tente novamente.',
  selectAtLeastOne: 'Selecione pelo menos um modelo.',
  close: 'Fechar',
  deletedModelsTitle: 'Modelos excluídos',
  deletedModelsDescription: 'Restaure modelos excluídos nos últimos 7 dias.',
  ngtorchTitle: 'Override de versão do ngtorch',
  ngtorchDescription: 'Rode o ngtorch a partir de um branch ou de um commit específico. Enquanto estiver definido, cada plano, model report, EKRM e modelo DIY que você disparar sobe uma VM com essa versão em vez da que vem na imagem. Afeta apenas você, e apenas neste ambiente.',
  ngtorchBranchLabel: 'Branch',
  ngtorchCommitLabel: 'Ou um commit',
  ngtorchBranchHint: 'Segue o branch: cada execução sobe o commit mais recente dele.',
  ngtorchCommitHint: 'Id de commit completo ou curto. Fixa esse commit exato e tem prioridade sobre o branch acima.',
  ngtorchRefsTruncated: 'A lista de branches foi truncada. Cole um id de commit se não encontrar o branch que procura.',
  ngtorchReinstallLabel: 'Reinstalar metadados do pacote',
  ngtorchReinstallHint: 'Mais lento. Só é necessário se o branch mudar o empacotamento, por exemplo ao adicionar um módulo novo ou um entry point.',
  ngtorchDependencyWarning: 'Um branch que adiciona ou atualiza uma dependência de terceiros não pode rodar assim e continua exigindo uma imagem reconstruída.',
  ngtorchApplyButton: 'Aplicar',
  ngtorchDisableButton: 'Desativar override',
  ngtorchActiveTitle: 'Rodando sobre {ref}',
  ngtorchResolvedTo: 'Fixado em {sha}',
  ngtorchFollowingTitle: 'Seguindo o branch {ref}',
  ngtorchFollowingNote: 'Cada execução sobe o commit mais recente deste branch. Da última vez ele foi resolvido para {sha}:',
  ngtorchApplied: 'Override do ngtorch definido em {ref} ({sha}).',
  ngtorchDisabled: 'Override do ngtorch desativado.',
  ngtorchNotFound: '"{ref}" não é um branch, tag nem commit do ngtorch.',
  ngtorchApplyError: 'Não foi possível definir o override do ngtorch. Tente novamente.',
  ngtorchLoadRefsError: 'Não foi possível carregar a lista de branches do ngtorch.'
}
